import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { environment } from '@src/environments/environment';

@Component({
    selector: 'app-tg-bot-entry-card',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './tg-bot-entry-card.component.html',
    styleUrls: ['./tg-bot-entry-card.component.less'],
})
export class TgBotEntryCardComponent {
    @Input() type: 'hunter_agent' | 'nyx_agent' = 'hunter_agent';

    get title() {
        return this.type === 'hunter_agent' ? 'Hemera Analyst Agent' : 'NyX Hunter Agent';
    }

    get description() {
        return this.type === 'hunter_agent'
            ? '🔔 Get daily market updates and trending token alerts from your Watchlist.'
            : '🚀 Real-time alpha, portfolio tools, and copy trading—tailored to your strategy.';
    }

    constructor(private walletStatusService: WalletStatusService) {}

    linkToBot() {
        if (this.type === 'hunter_agent') {
            if (this.walletStatusService.userProfile?.telegram_id || !this.walletStatusService.userProfile) {
                window.open(environment.telegram.botLink, '_blank');
            } else {
                window.open(`${environment.telegram.botLink}?start=bind_${this.walletStatusService.userProfile.id}`, '_blank');
            }
        }

        if (this.type === 'nyx_agent') {
            window.open('https://t.me/nyx_agent_bot', '_blank');
        }
    }
}
